import axios from 'axios';
import Swal from 'sweetalert2';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

export const adminAttendanceBulk = async (data) => {
    try {
        const formData = new FormData();
        formData.append("file", data);
        console.log('Sending file:', data.name, data.size);

        const res = await axios.post("/adminAtendances/missedpunch/bulkupload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            timeout: 600000, // 10 minutes timeout for large bulk uploadsss
        });

        if (res.status === 200) {
            if (res.data.skippedRecords && res.data.skippedRecords.length > 0) {
                // Auto download Excel file with all failed records and exact error reasons
                if (res.data.excelFile) {
                    downloadExcelFile(res.data.excelFile, res.data.fileName);
                } else {
                    generateAndDownloadSkippedExcel(res.data.skippedRecords);
                }

                const skippedText = res.data.skippedRecords
                    .map(record => `
                        <div style="margin-bottom: 8px; border-bottom: 1px dashed #dee2e6; padding-bottom: 6px;">
                            <strong style="color: #495057;">Row ${record.row_number || '-'}:</strong> 
                            <span style="background: #e9ecef; padding: 2px 6px; border-radius: 4px; font-weight: 500;">EPF: ${record.epf_number || 'N/A'}</span>
                            <div style="color: #dc3545; font-weight: 600; margin-top: 2px; font-size: 13px;">
                                ⚠️ ${record.error}
                            </div>
                        </div>
                    `)
                    .join('');
                
                Swal.fire({
                    icon: "warning",
                    title: "Upload completed with errors",
                    html: `
                        <div style="text-align: left; padding: 0px 5px;">
                            <div style="display: flex; justify-content: space-between; background: #f8f9fa; padding: 12px; border-radius: 6px; margin-bottom: 12px; border: 1px solid #e9ecef;">
                                <span><strong style="color: #28a745;">✓ Successful Records:</strong> ${res.data.successfulCount || 0}</span>
                                <span><strong style="color: #dc3545;">⚠️ Failed / Skipped:</strong> ${res.data.skippedCount || res.data.skippedRecords.length}</span>
                            </div>
                            <p style="font-weight: bold; margin-bottom: 6px; color: #333;">Failed Records Summary:</p>
                            <div style="max-height: 250px; overflow-y: auto; font-size: 13px; background: #fff; border: 1px solid #ced4da; border-radius: 6px; padding: 12px;">
                                ${skippedText}
                            </div>
                            <hr style="margin: 12px 0;">
                            <p style="color: #28a745; font-weight: bold; margin: 0; text-align: center; font-size: 14px;">
                                📥 Complete error report Excel file has been automatically downloaded!
                            </p>
                        </div>
                    `,
                    width: '650px',
                    showConfirmButton: true,
                    confirmButtonText: 'OK'
                });
            } else {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: `Successfully uploaded ${res.data.successfulCount || 0} records`,
                });
            }
        }
    } catch (error) {
        console.error("Bulk upload error:", error.message, error.stack);
        const errorMessage = error.response?.data?.error || error.message || "An unexpected error occurred during the bulk upload.";
        Swal.fire({
            icon: "error",
            title: "Upload Error",
            text: errorMessage,
        });
        throw error;
    }
};

// Function to generate and download Excel file for skipped records
const generateAndDownloadSkippedExcel = (skippedRecords) => {
    try {
        const exportData = skippedRecords.map((rec) => ({
            "Record No": rec.record_number || "",
            "EPF No": rec.epf_number || "",
            "Date": rec.date || "",
            "Clock In": rec.clock_in || "",
            "Clock Out": rec.clock_out || "",
            "Reason": rec.reason || "",
            "Error Reason": rec.error || "Unknown Error"
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Failed Records");

        const fileName = `attendance_failed_records_${new Date().toISOString().slice(0, 10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    } catch (error) {
        console.error("Error generating skipped records excel:", error);
    }
};

// Function to automatically download Excel file
const downloadExcelFile = (base64Data, fileName) => {
    try {
        // Convert base64 to blob
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });

        // Create download link and trigger download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading Excel file:', error);
    }
};





//bulk upload controller for create employee

export const createEmployeeBulk = async (data) => {

    try {

        const res = await axios.post(`/employees/bulk-upload`, {
            csv: data,
            //user: adminId
        });
        if (res.status === 201) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Successfully uploaded bulk data",
            });
        }

    } catch (error) {

        if (error.response) {
            const {skippedRecords} = error.response.data;

            if (skippedRecords && skippedRecords.length > 0) {
                const skippedText = skippedRecords
                    .map(record => {
                        const rowText = record.recordNo ? `Row ${record.recordNo}` : "Row Unknown";
                        const fieldLabel = record.field === "nic"
                            ? "NIC"
                            : record.field === "epf_number"
                                ? "EPF"
                                : "Identifier";
                        return `${rowText} - ${fieldLabel}: ${record.employee || "N/A"}, Reason: ${record.reason}`;
                    })
                    .join('<br>');

                Swal.fire({
                    icon: "warning",
                    title: "The following records were skipped",
                    html: `<p style="font-size: 17px; text-align: left; padding: 0px 27px;">\n\n${skippedText}</p>`,
                });
            }
        } else {
            console.error("An error occurred during the bulk upload:", error);
        }
    }
};

export const createDeductionBulk = async (data) => {

    try {

        const res = await axios.post(`/deduction/bulk-upload`, {
            csv: data,
            //user: adminId
        });
        if (res.status === 201) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Successfully uploaded bulk data",
            });
        }


    } catch (error) {
        if (error.response) {
            const {skippedRecords} = error.response.data;

            if (skippedRecords && skippedRecords.length > 0) {
                const skippedText = skippedRecords
                    .map(record => `Record: ${record.recordNumber}, Reason: ${record.reason}`)
                    .join('<br>');

                Swal.fire({
                    icon: "warning",
                    title: "The following records were skipped",
                    html: `<p style="font-size: 17px; text-align: left; padding: 0px 27px;">\n\n${skippedText}</p>`,
                });
            }
        } else {
            console.error("An error occurred during the bulk upload:", error);
        }
    }
};



export const createLeavesBulk = async (data) => {
    try {
        const res = await axios.post(`/leaves-bulk-upload-new`, {
            csv: data,
        });
        if (res.status === 201) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Successfully uploaded bulk data",
            });
        }
    } catch (error) {
        console.log(error)
        if (error.response) {
            const {skippedRecords} = error.response.data;

            if (skippedRecords && skippedRecords.length > 0) {
                const skippedText = skippedRecords
                    .map(record => `Record: ${record.recordNumber}, Reason: ${record.reason}`)
                    .join('<br>');

                Swal.fire({
                    icon: "warning",
                    title: "The following records were skipped",
                    html: `
                        <p style="font-size: 17px; text-align: left; padding: 0px 27px;">
                            ${skippedText}
                        </p>
                        <div style="margin-top: 20px;">
                            <button id="downloadSkippedCSV" class="btn btn-primary" style="margin-right: 10px; background-color: #007bff; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer;">
                                Download as CSV
                            </button>
                            <button id="downloadSkippedExcel" class="btn btn-success" style="background-color: #28a745; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer;">
                                Download as Excel
                            </button>
                        </div>
                    `,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    didOpen: () => {
                        document.getElementById('downloadSkippedCSV').addEventListener('click', () => {
                            downloadSkippedRecordsAsCSV(skippedRecords, data);
                        });
                        
                        document.getElementById('downloadSkippedExcel').addEventListener('click', () => {
                            downloadSkippedRecordsAsExcel(skippedRecords, data);
                        });
                    }
                });
            }
        } else {
            console.error("An error occurred during the bulk upload:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An error occurred during the bulk upload",
            });
        }
    }
};

// Helper functions remain the same
const downloadSkippedRecordsAsCSV = (skippedRecords, originalData) => {
    const skippedData = skippedRecords.map(skipped => {
        const originalRecord = originalData.find(record => 
            record.record_number === skipped.recordNumber
        );
        
        return {
            record_number: skipped.recordNumber,
            leave_days: originalRecord?.leave_days || '',
            epf_number: originalRecord?.epf_number || '',
            leave_type: originalRecord?.leave_type || '',
            appplied_on: originalRecord?.appplied_on || '',
            status: originalRecord?.status || '',
            reason: originalRecord?.reason || '',
            skip_reason: skipped.reason
        };
    });

    const csv = Papa.unparse(skippedData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', `skipped_records_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const downloadSkippedRecordsAsExcel = (skippedRecords, originalData) => {
    const skippedData = skippedRecords.map(skipped => {
        const originalRecord = originalData.find(record => 
            record.record_number === skipped.recordNumber
        );
        
        return {
            'Record Number': skipped.recordNumber,
            'Leave Days': originalRecord?.leave_days || '',
            'EPF Number': originalRecord?.epf_number || '',
            'Leave Type': originalRecord?.leave_type || '',
            'Applied On': originalRecord?.appplied_on || '',
            'Status': originalRecord?.status || '',
            'Reason': originalRecord?.reason || '',
            'Skip Reason': skipped.reason
        };
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(skippedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Skipped Records');
    XLSX.writeFile(workbook, `skipped_records_${new Date().toISOString().split('T')[0]}.xlsx`);
};

export const createAllowanceBulk = async (data) => {
    try {
        const res = await axios.post(`/allowance-bulk-upload`, { csv: data });
        const { skippedRecords = [], createdCount = 0, updatedCount = 0, message } = res.data || {};

        if (res.status === 201) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: message || "Successfully uploaded allowance records",
            });
            return;
        }

        if (res.status === 207) {
            const skippedText = skippedRecords
                .slice(0, 10)
                .map(record => `Record: ${record.recordNumber}, Reason: ${record.reason}`)
                .join('<br>');
            const moreText = skippedRecords.length > 10 ? `<br><strong>...and ${skippedRecords.length - 10} more</strong>` : "";

            Swal.fire({
                icon: "warning",
                title: "Uploaded with some issues",
                html: `
                    <div style="text-align: left; padding: 0px 20px;">
                        <p><strong>Created:</strong> ${createdCount}</p>
                        <p><strong>Updated:</strong> ${updatedCount}</p>
                        <p><strong>Skipped:</strong> ${skippedRecords.length}</p>
                        <hr>
                        <p><strong>Skipped records (first 10):</strong></p>
                        <div style="max-height: 200px; overflow-y: auto; font-size: 14px;">
                            ${skippedText || 'No details provided.'}${moreText}
                        </div>
                    </div>
                `,
            });
            return;
        }

        Swal.fire({
            icon: "info",
            title: "Completed",
            text: message || "Bulk upload finished",
        });
    } catch (error) {
        const skippedRecords = error.response?.data?.skippedRecords;
        if (skippedRecords && skippedRecords.length > 0) {
            const skippedText = skippedRecords
                .map(record => `Record: ${record.recordNumber}, Reason: ${record.reason}`)
                .join('<br>');

            Swal.fire({
                icon: "warning",
                title: "The following records were skipped",
                html: `<p style="font-size: 17px; text-align: left; padding: 0px 27px;">\n\n${skippedText}</p>`,
            });
            return;
        }

        console.error("An error occurred during the bulk upload:", error);
        Swal.fire({
            icon: "error",
            title: "Upload Error",
            text: error.response?.data?.message || error.message || "An unexpected error occurred during the bulk upload.",
        });
    }
};

export const leaveAllocationBulk = async (data) => {

    try {

        const res = await axios.post(`/leaveAllocation-bulk-upload`, {
            csv: data,
            year: new Date().getFullYear()
        });
        if (res.status === 201) {
            const count = res.data?.successfulCount || 0;
            Swal.fire({
                icon: "success",
                title: "Success",
                text: `Successfully uploaded and processed ${count} leave allocation records`,
            });
            return;
        }

        if (res.status === 207) {
            const { skippedRecords = [], message, successfulCount = 0 } = res.data || {};
            if (skippedRecords && skippedRecords.length > 0) {
                const skippedText = skippedRecords
                    .map(record => `Record: ${record.recordNumber}, Type: ${record.leaveTypeName || ''}, Reason: ${record.reason}`)
                    .join('<br>');

                Swal.fire({
                    icon: "warning",
                    title: "The following records were skipped",
                    html: `
                        <p style="text-align: left; padding: 0px 20px;"><strong>Successful records:</strong> ${successfulCount}</p>
                        <p style="font-size: 17px; text-align: left; padding: 0px 27px;">\n\n${skippedText}</p>
                    `,
                });
            } else {
                Swal.fire({
                    icon: "info",
                    title: "Uploaded with issues",
                    text: message || "Bulk upload finished with some issues.",
                });
            }
            return;
        }


    } catch (error) {
        if (error.response) {
            const {skippedRecords} = error.response.data;

            if (skippedRecords && skippedRecords.length > 0) {
                const skippedText = skippedRecords
                    .map(record => `Record: ${record.recordNumber}, Reason: ${record.reason}`)
                    .join('<br>');

                Swal.fire({
                    icon: "warning",
                    title: "The following records were skipped",
                    html: `<p style="font-size: 17px; text-align: left; padding: 0px 27px;">\n\n${skippedText}</p>`,
                });
            }
        } else {
            console.error("An error occurred during the bulk upload:", error);
        }
    }
};